const blogContext = require.context("./content/blogs", false, /\.js$/);

const generateSlug = (title) => {
  return title
    .toLowerCase()
    .replace(/&/g, "and")
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-|-$/g, "");
};

export function loadBlogs() {
  return blogContext.keys().map((key) => {
    const blog = blogContext(key).default || blogContext(key);
    const slug = generateSlug(blog.title);
    return { slug, ...blog };
  });
}
